import React from "react";
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import SideNav from '../../shared/Sidenav';
import Button from "../../shared/Button";
import add from '../../../assets/images/add.svg';
import edit from '../../../assets/images/edit.svg';
import deletedisable from '../../../assets/images/delete_enable.svg';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import '../../../css/advertisement/Advertisement.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdvertisementData from './AdvertisementData';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ADVERTISEMENTS_ENDPOINT, DELETEADVERTISEMENT_ENDPOINT, DOWNLOAD_ENDPOINT } from '../../../Services/config/apiEndPoints';
import EditAdvertisementData from "./EditAdvertisementData";
import DeleteModal from '../../shared/DeleteRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import PreviewModal from '../../shared/PreviewModal';
import AvailableSlots from './AvailableSlots';
import { AES, enc } from 'crypto-js';
import Cookies from 'cookies-js';
import { connect } from 'react-redux';
let advertisementIndex = '';
const urlPath = utilityBaseURL + DOWNLOAD_ENDPOINT + "?documentPath=";
let viewOnly = false;
var decodeImage = [];
class Advertisement extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasOpen: false,
            hasOpenEdit: false,
            advertisementData: [],
            editIndex: '',
            previewIndex: '',
            editModalCall: false,
            hasOpenDelete: false,
            confirmedHasOpen: false,
            deleteIndex: '',
            hasOpenImagePreview: false,
            viewAvailableSlots: false,
        }
    }
    componentDidMount = () => {
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 15) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            utilityBaseURL + ADVERTISEMENTS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    console.log("No Advertisement")
                }
                else {
                    console.log('I am 200!');
                    this.setState({ advertisementData: apiData });
                    console.log(this.state.advertisementData);
                    console.log(apiData.map(a => (a.aDImageWebLink)))
                    let testAccess = Cookies.get('msAL_admin_dev');
                    testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
                    if (apiData.length > 0) {
                        apiData.map((name, index) => {
                            console.log("in xml function");
                            var xhr = new XMLHttpRequest();
                            var URLToImage = urlPath + apiData[index].aDImageWebLink;
                            xhr.open("GET", URLToImage, true);
                            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
                            // Ask for the result as an ArrayBuffer.
                            xhr.responseType = "arraybuffer";
                            xhr.onload = function (e) {
                                // Obtain a blob: URL for the image data.
                                var arrayBufferView = new Uint8Array(this.response);
                                var blob = new Blob([arrayBufferView], { type: "image/jpg" });
                                var urlCreator = window.URL || window.webkitURL;
                                var imageUrl = urlCreator.createObjectURL(blob);
                                decodeImage[index] = imageUrl;
                                console.log("decode url", imageUrl);
                            };
                            xhr.send();
                        }
                        )
                    }
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    getTime = (timeStamp) => {
        return new Date(Number(timeStamp)).toGMTString().split(' ')[4].substring(0, 5);
    }
    getPublishDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toGMTString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    getDate = (dateString) => {
        //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
        let dateParts = dateString.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        window.location.reload();
    };
    onCloseEditModal = () => {
        this.setState({ hasOpenEdit: false });
        window.location.reload();
    };
    onAddHandleUser = () => {
        this.setState({ hasOpen: true });
    }
    onEditHandleUser = (index) => {
        this.setState({ editIndex: index })
        this.setState({ editModalCall: true });
        this.setState({ hasOpenEdit: true });
    }
    onPreviewHandler = (index) => {
        this.setState({ previewIndex: index });
        this.setState({ hasOpenImagePreview: true })

    }
    visitUrl = (event) => {
        if (this.state.advertisementData[event].aDLink.includes('https://') || this.state.advertisementData[event].aDLink.includes('http://')) {
            window.open(this.state.advertisementData[event].aDLink, "_blank");
        }
        else {
            window.open("//" + this.state.advertisementData[event].aDLink, "_blank");
        }
    }
    onCloseDeleteModal = () => {
        this.setState({ hasOpenDelete: false });
    }
    onClosePreviewModal = () => {
        this.setState({ hasOpenImagePreview: false });
    }
    confirmDelete = (index) => {
        console.log(this.state.deleteIndex)
        console.log("sss", this.state.advertisementData[this.state.deleteIndex])
        console.log(utilityBaseURL + DELETEADVERTISEMENT_ENDPOINT + `?adId=${this.state.advertisementData[this.state.deleteIndex].adId}`)
        ApiCall(
            'DELETE',
            utilityBaseURL + DELETEADVERTISEMENT_ENDPOINT + `?adId=${this.state.advertisementData[this.state.deleteIndex].aDId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
                else {
                    console.log('I am 200!');
                    console.log(apiData.message);
                    this.setState({ confirmedHasOpen: true });
                    this.setState({ hasOpenDelete: false });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    onDeleteAdvertisement = (index) => {
        console.log("delete index", index);
        this.setState({ deleteIndex: index, hasOpenDelete: true });
    }
    renderTableData() {
        return this.state.advertisementData.map((details, index) => {
            return (
                <>
                    <tr key={index} id="advertisementdata">
                        <td className="tabledata" id="bodySno">{index + 1}</td>
                        <td className="tabledata" id="bodyADno">{"AD" + (details.aDId)}</td>
                        <td className="tabledata" id="bodyAdCompany">{details.aDCompany}</td>
                        <td className="tabledata" id="bodyPublishdt">{this.getPublishDate(details.publishTime)} {this.getTime(details.publishTime)}</td>
                        <td className="tabledata" id="bodyFromdt">{this.getDate(details.fromDate)} </td>
                        <td className="tabledata" id="bodyTodt">{this.getDate(details.toDate)} </td>
                        <td className="preview" id="bodyDesktopimg"><Link onClick={() => this.onPreviewHandler(index)} id="previewColorblue">Preview</Link></td>
                        <td className="preview" id="bodyUrl">
                            <div data-tip={details.aDLink} data-offset="{'top': 0, 'left': 15}">
                                <div className="preview">
                                    <a onClick={() => this.visitUrl(index)}
                                        class="tooltip" id="urlView">View</a>
                                </div>
                            </div>
                            <ReactTooltip place="bottom" effect='solid' arrowColor="#6F6F6F" backgroundColor="#6F6F6F" multiline={true} className="serviceDescriptionReactTooltip" />

                        </td>
                        <td className="editDelete" style={{
                            display:
                                !viewOnly ? "none" : null
                        }}>
                            <div id="partition"><img src={edit} alt="" onClick={() => { this.onEditHandleUser(index); advertisementIndex = index }} /></div></td>
                        <td className="editDelete" style={{
                            display:
                                !viewOnly ? "none" : null
                        }}>
                            <div className="deleteAd">
                                <img src={deletedisable} onClick={() => this.onDeleteAdvertisement(index)} alt="" />
                            </div>
                        </td>
                    </tr>
                </>
            )
        })
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="sno" className="tableHeaderText">S. No.</td>
                    <td id="adNo" className="tableHeaderText">Advertisement No.</td>
                    <td id="adCompany" className="tableHeaderText">Advertising Company</td>
                    <td id="publishdt" className="tableHeaderText">Published Date & Time </td>
                    <td id="fromdt" className="tableHeaderText">Effective Date</td>
                    <td id="todt" className="tableHeaderText">Expiry Date</td>

                    <td id="mobileWebimg" className="tableHeaderText">Image</td>

                    <td id="url" className="tableHeaderText">URL</td>
                    <td style={{
                        display:
                            !viewOnly ? "none" : "flex"
                    }}></td>
                    <td style={{
                        display:
                            !viewOnly ? "none" : "flex"
                    }}></td>
                </tr>
            </>
        )
    }
    render() {
        return (
            <div className="outer1" ><div className="outer1" id="outerdiv" >
                <MetaDecorator title={TitleDescription.advertisementPageTitle} description={TitleDescription.advertisementPageDescription} />
                <div className="adhome">
                    <SideNav />
                    <div id="advertisementPart" >
                        <div className="advertisementHeading">
                            <h1 id='advertisementtitle'>Advertisement</h1>
                            <Button class="viewSlots" onClick={() => this.setState({ viewAvailableSlots: true })}>View Available Slots</Button>
                        </div>
                        <div className="viewOnlyDiv" style={{
                            display:
                                // role > 0 && 
                                !viewOnly ? null : "none"
                        }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="contentbox">
                            <table>
                                <thead className="adHeading">
                                    {this.renderTableHeader()}
                                </thead>
                            </table>
                            <div className="adContent">
                                <table id='details'>
                                    <tbody >

                                        {this.renderTableData()}
                                    </tbody>
                                </table>
                            </div>
                            <div id="tableFooter" style={{
                                display:
                                    !viewOnly ? "none" : "flex"
                            }}>
                                <Link onClick={this.onAddHandleUser}><img src={add} alt="" width="19" height="19" id="advertisementaddrole" /> <small className="addAdvertisementText">Add New Advertisement</small></Link>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.hasOpen ? <AdvertisementData onClick={this.onCloseModal} onClosePublish={this.onCloseModal} /> : null}
                {this.state.hasOpenEdit || this.state.editModalCall ?
                    <EditAdvertisementData onClick={this.onCloseEditModal} onClosePublish={this.onCloseEditModal} decodeUrl={decodeImage[this.state.editIndex]} advertisementData={this.state.advertisementData} editIndex={this.state.editIndex} advertisementEditIndex={advertisementIndex} /> : null}
                <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
                    <p className="deletemodalText">Do you really want to delete this advertisement?</p>
                </DeleteModal>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
                {this.state.viewAvailableSlots &&
                    <AvailableSlots onClick={() => this.setState({ viewAvailableSlots: false })} />
                }
                {this.state.hasOpenImagePreview ?
                    <PreviewModal onClick={this.onClosePreviewModal} mobileImg={this.state.advertisementData.aDImageMobileLink}
                        advertisementData={decodeImage}
                        previewIndex={this.state.previewIndex}
                    /> : null}
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(Advertisement);